namespace RecordShield.Administration {
    export interface UserRoleListResponse extends Serenity.ListResponse<number> {
    }
}

